export enum ModuleTokens {
  Name = 'ticketRealizationDate'
}
